module.exports = __webpack_public_path__ + "img/icono_mail.cd536a20.png";